module.exports = __webpack_public_path__ + "static/img/jj2.23e1895c.jpg";